export default __webpack_public_path__ + "static/media/gyroX.3c5c1e21.svg";